import React from "react";
import { SidebarWrapper, LogOutButon } from "./AdminDashboardLayout.styled";
import fortCore from "../assets/fortcore.png";
import leaseIcon from "../assets/icons/leaseIcon.svg";
import logOutIcon from "../assets/icons/Logout.svg";
import financeIcon from "../assets/icons/financeIcon.svg";
import travelIcon from "../assets/icons/travel.svg";
// import bankIcon from "../assets/icons/bank.svg";
// import transactionIcon from "../assets/icons/Transactions.svg";
import productIcon from "../assets/icons/productIcon.svg";
import usersIcon from "../assets/icons/UsersIcon.svg";
import adminsIcon from "../assets/icons/adminIcon.svg";
import boxIcon from "../assets/icons/box.svg";
import logisticsIcon from "../assets/icons/logisticsIcon.svg";
// import schemeIcon from "../assets/icons/scheme.svg"
// import recoveryIcon from "../assets/icons/recoveryIcon.svg";
import accountIcon from "../assets/icons/workIcon.svg";
import { NavLink } from "react-router-dom";
import { BiHome } from "react-icons/bi";
import { FiBookOpen } from "react-icons/fi";
import { canAccessService } from "../utils/UserAuth";

// eslint-disable-next-line react/prop-types
function Sidebar({ logOutFunc }) {
	return (
		<SidebarWrapper>
			<header>
				<img src={fortCore} style={{ width: "140px", margin: "10px 6px" }} alt="FortCore's Logo" />
			</header>

			<section>
				<NavLink to='/' className={({ isActive }) => (isActive ? "active " : "")}>
					<div className='navItem'>
						<BiHome size={24} />
						<p>Dashboard</p>
					</div>
				</NavLink>

				{canAccessService(["lease", "apprenticeship"]) && (
					<>
						<NavLink to='/lease' className={({ isActive }) => (isActive ? "active " : "")}>
							<div>
								<img className='icon' src={leaseIcon} alt='NavIcon' />
								<p>Lease</p>
							</div>
						</NavLink>

						<NavLink to='/apprenticeship' className={({ isActive }) => (isActive ? "active " : "")}>
							<div>
								<img className='icon' src={financeIcon} alt='NavIcon' />
								<p className='leading-5'>Apprenticeship Finance</p>
							</div>
						</NavLink>
					</>
				)}

				{canAccessService(["travel-advance"]) && (
					<NavLink to='/travel-advance' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={travelIcon} alt='travel icon' />
							<p className='leading-5'>Travel Advance</p>
						</div>
					</NavLink>
				)}

				{canAccessService(["education"]) && (
					<NavLink to='/education' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<FiBookOpen size={24} />
							<p>Education</p>
						</div>
					</NavLink>
				)}

				{/* <NavLink to='/transactions' className={({ isActive }) => (isActive ? "active " : "")}>
					<div>
						<img
							className='icon'
							src={transactionIcon}
							alt='NavIcon'
						/>
						<p>Transactions</p>
					</div>
				</NavLink> */}

				{canAccessService(["products"]) && (
					<NavLink to='/products' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={productIcon} alt='NavIcon' />
							<p className='leading-5'>Products Catalogue</p>
						</div>
					</NavLink>
				)}

				{canAccessService(["customer"]) && (
					<NavLink to='/customer' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={usersIcon} alt='NavIcon' />
							<p>Customer Management</p>
						</div>
					</NavLink>
				)}

				{canAccessService(["users"]) && (
					<NavLink to='/users' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={adminsIcon} alt='NavIcon' />
							<p>Users Management</p>
						</div>
					</NavLink>
				)}

				{/* <NavLink to='/bank' className={({ isActive }) => (isActive ? "active " : "")}>
					<div>
						<img className='icon' src={bankIcon} alt='bank icon' />
						<p>Bank</p>
					</div>
				</NavLink> */}

				{canAccessService(["logistics"]) && (
					<NavLink to='/logistics' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={logisticsIcon} alt='Nav icon' />
							<p>Logistics</p>
						</div>
					</NavLink>
				)}

				{/* <NavLink to='/recovery' className={({ isActive }) => (isActive ? "active " : "")}>
					<div>
						<img className='icon' src={recoveryIcon} alt='NavIcon' />
						<p>Recovery</p>
					</div>
				</NavLink> */}

				{canAccessService(["account"]) && (
					<NavLink to='/account' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={accountIcon} alt='NavIcon' />
							<p>Apprenticeship Account Manager</p>
						</div>
					</NavLink>
				)}
{/* 
				{canAccessService(["scheme"]) && (
					<NavLink to='/scheme' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={schemeIcon} alt='NavIcon' />
							<p>Scheme Owner</p>
						</div>
					</NavLink>
				)} */}

				{canAccessService(["parameters"]) && (
					<NavLink to='/parameters' className={({ isActive }) => (isActive ? "active " : "")}>
						<div>
							<img className='icon' src={boxIcon} alt='Sidebar icon' />
							<p>Parameters</p>
						</div>
					</NavLink>
				)}
			</section>

			<LogOutButon onClick={logOutFunc} type='button'>
				<img src={logOutIcon} alt='logout icon' />
				Log Out
			</LogOutButon>
		</SidebarWrapper>
	);
}

export default Sidebar;
